export default __webpack_public_path__ + "static/prakhar-shrivastava-a052d082a0c911454e4cd85ec8dda866.svg";